"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingEnvUserError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const errorCode = "MissingEnvironmentVariable";
const messageKey = "driver.aadApp.error.missingEnv";
class MissingEnvUserError extends teamsfx_api_1.UserError {
    constructor(actionName, missingEnvs, helpLink, additionalMessageKey) {
        let envList;
        if (Array.isArray(missingEnvs)) {
            envList = missingEnvs.join(", ");
        }
        else {
            envList = missingEnvs;
        }
        super({
            source: actionName,
            name: errorCode,
            message: localizeUtils_1.getDefaultString(additionalMessageKey) + " " + localizeUtils_1.getDefaultString(messageKey, envList),
            displayMessage: localizeUtils_1.getLocalizedString(additionalMessageKey) + " " + localizeUtils_1.getLocalizedString(messageKey, envList),
            helpLink: helpLink,
        });
    }
}
exports.MissingEnvUserError = MissingEnvUserError;
//# sourceMappingURL=missingEnvError.js.map